import { Mail01 } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import OrbAvatar from 'src/components/OrbAvatar';

import ActionCard from './ActionCard';

interface AgentEmptyStateProps {
    greetingName?: string;
    onOpenNewDomain?: () => void;
}

const AgentEmptyState = ({ greetingName, onOpenNewDomain }: AgentEmptyStateProps) => (
    <div className="flex-1 flex flex-col animation-content-fade">
        <div className="flex-1 flex flex-col items-center justify-center gap-y-3 text-center animation-slide-to-top">
            <OrbAvatar size={60} />
            <div className="space-y-3 w-full animation-slide-in-from-below">
                <div className="space-y-0.5 animation-empty-text">
                    <p className="text-base font-semibold text-gray400">Hey {greetingName || 'there'}! 👋</p>
                    <p className="text-base font-semibold text-textSecondary">How can I assist you?</p>
                </div>
                <button
                    type="button"
                    className="inline-flex items-center gap-x-1.5 px-3 py-1.5 rounded-lg border border-utilityGray200 bg-utilityGray100 text-grayLight600 text-xs font-normal cursor-default"
                >
                    <span className="bg-primary rounded-full h-2 w-2 flex-shrink-0" />
                    What&apos;s New?
                </button>
                {onOpenNewDomain && (
                    <div className="flex justify-center">
                        <ActionCard icon={<Mail01 className="w-4 h-4" />} title="New domain — needs your match" onClick={onOpenNewDomain} />
                    </div>
                )}
            </div>
        </div>
    </div>
);

export default AgentEmptyState;
